import { observer } from 'mobx-react-lite';
import ProposalSection, { ProposalSectionEditableProps } from './ProposalSection';
import { ProposalDto } from '@gap/backend/app-services/proposal/models/ProposalDto';
import Typography from "@mui/material/Typography"
import proposalObjectivesAndValues from '@gap/utils/proposals/proposalObjectivesAndValues';
import { useMemo } from 'react';

type ProposalSectionObjectivesProps = {
   proposal: ProposalDto,
   sectionProps?: ProposalSectionEditableProps,
}

export default observer(function ProposalSectionObjectives({ proposal, sectionProps }: ProposalSectionObjectivesProps) {
   const objectives = useMemo(() => {
      const rawObjectives = proposalObjectivesAndValues.categories.flatMap((c) => [...(c.items || []), ...(c.subcategories?.flatMap((s) => (s.items)) || [])]) || []
      return (proposal.step4?.objectivesAndValue || []).map((objectiveId) => rawObjectives.find(({ id }) => objectiveId === id)).map((item) => item?.objective)
   }, [proposal.step4?.objectivesAndValue])

   if (objectives.length === 0) return null

   return <ProposalSection
      heading="Objectives & Value"
      subheading={`These are the key objectives we'll set out to achieve together and the value you'll
               receive in return when deciding to work with us.`}
      {...sectionProps}
   >
      <Typography variant="body1" component="ul">
         {objectives.map((objective, index) => <li key={index}>{objective}</li>)}
      </Typography>
   </ProposalSection>
})
